import React, { useState, useEffect, useRef } from "react";
import { Backdrop, CircularProgress, Button } from "@mui/material";
import { useNavigate, Link } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { Table, BarChart } from "react-bootstrap-icons"
import "./table.css";
import Select from "react-select";
import { MdRefresh } from "react-icons/md";
import { TabView, TabPanel } from "primereact/tabview";
import { MdNotificationsActive } from "react-icons/md";
import { BlobServiceClient } from "@azure/storage-blob";
import Highcharts from "highcharts"
import HighchartsReact from "highcharts-react-official"
const ESGBenchmarking = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    companyName: [],
    sector: [],
    country: [],
    competitors: [],
    year: [],
  });
  const [viewMode, setViewMode] = useState("table")
  const [data, setData] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [sectorOptions, setSectorOptions] = useState([]);
  const [competitorsOptions, setCompetitorsOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [nextToken, setNextToken] = useState(null);
  const [tab3total, setTab3Total] = useState();
  const [tab2total, setTab2Total] = useState();
  const [searchText, setSearchText] = useState("");
  const [fontSize, setFontSize] = useState(window.innerWidth >= 1400 ? "15px" : "13px");
  const username = localStorage.getItem("userName");

  const resetSelections = () => {
    setFormData({
      companyName: null, // ✅ Change from [] to null for clearing the dropdown
      sector: [],
      country: [],
      competitors: [],
      year: "",
    });
    setSearchText(""); 
    setFilteredEmissionsData([]);
    setFilteredTargetsData([]);
    setFilteredReportingData([]);
  };

  const [filteredEmissionsData, setFilteredEmissionsData] = useState([]);
  const [filteredTargetsData, setFilteredTargetsData] = useState([]);
  const [filteredReportingData, setFilteredReportingData] = useState([]);

  const fileInputRef = useRef(null);

  const handleUploadClick = () => {
    // Trigger the file input click
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event) => {
    // Access the uploaded files
    const files = event.target.files;
    if (files.length > 0) {
      console.log("Files selected:", files);
      // Add logic to handle file upload
    }
  };

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    companyName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    sector: { value: null, matchMode: FilterMatchMode.CONTAINS },
    country: { value: null, matchMode: FilterMatchMode.CONTAINS },
    year: { value: null, matchMode: FilterMatchMode.CONTAINS },
    revenue: { value: null, matchMode: FilterMatchMode.CONTAINS },
    employees: { value: null, matchMode: FilterMatchMode.CONTAINS },
    scope1Emissions: { value: null, matchMode: FilterMatchMode.CONTAINS },
    scope2Emissions: { value: null, matchMode: FilterMatchMode.CONTAINS },
    scope3Emissions: { value: null, matchMode: FilterMatchMode.CONTAINS },
    totalEmissions: { value: null, matchMode: FilterMatchMode.CONTAINS },
    economicEmissionIntensity: {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
    emissionIntensityPerEmployees: {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
  });

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [emissionsData, setEmissionsData] = useState([]);
  const [targetsData, setTargetsData] = useState([]);
  const [reportingData, setReportingData] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [companyFilter, setCompanyFilter] = useState("");
  const [sectorFilter, setSectorFilter] = useState("");
  const [countryFilter, setCountryFilter] = useState("");
  const [yearFilter, setYearFilter] = useState("");
  const [competitorFilter, setCompetitorFilter] = useState([]);
  const [graphData, setGraphData] = useState([]);

  const yesNoOptions = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
  ];

  useEffect(() => {
    fetchDatas();
    onPageLoadFilter();
    fetchGraphData();
  }, [formData]);

  // Determine if filters are applied
  const isFilterApplied = Object.values(formData).some((value) => value);

  const fetchDatas = async () => {
    setLoading(true);
    try {
      // Define the API URLs and their corresponding request bodies
      const requestBody = {
        companyNames: formData.companyName?.length > 0 ? [formData.companyName] : [],
        sectors: formData.sector?.length > 0 ? formData.sector : [],
        countries: formData.country?.length > 0 ? formData.country : [],
        competitors: formData.competitors?.length > 0 ? formData.competitors : [],
        years: formData.year ? formData.year : null,
      };
      const apiRequests = [
        {
          url: `${process.env.REACT_APP_BASE_API_URL}emission-benchmarking`,
          body: requestBody,
          setData: setEmissionsData,
        }
      ];

      // Make concurrent requests
      const responses = await Promise.all(
        apiRequests.map(({ url, body }) =>
          fetch(url, {
            method: "POST",
            headers: {
              "Content-type": "application/json; charset=UTF-8",
              username,
            },
            body: JSON.stringify(body),
          })
        )
      );

      // Process the responses
      await Promise.all(
        responses.map(async (res, index) => {
          const { setData } = apiRequests[index];
          if (res.status === 200) {
            const responseJson = await res.json();
            if(responseJson.status === 400){
              setData();
            }
            else{
              setData(responseJson);
            }
            
            
          } else {
            console.error(`Error with API: ${apiRequests[index].url}`);
          }
        })
      );
    } catch (error) {
      console.error("Error", error);
    } finally {
      await new Promise((resolve) => setTimeout(resolve, 5000));
      setLoading(false);
    }
  };

  const onDropdownChange = (e, rowData, field) => {
    const updatedData = targetsData.map((row) => {
      if (row === rowData) {
        return { ...row, [field]: e.value };
      }
      return row;
    });
    setTargetsData(updatedData);
  };

  const onInputChange = (e, rowData, field) => {
    const updatedData = targetsData.map((row) => {
      if (row === rowData) {
        return { ...row, [field]: e.target.value };
      }
      return row;
    });
    setTargetsData(updatedData);
  };

  const netZeroTargetTemplate = (rowData) => {
    return <Dropdown value={rowData.netZeroTarget} options={yesNoOptions} onChange={(e) => onDropdownChange(e, rowData, "netZeroTarget")} placeholder="Yes/No" />;
  };

  const nearTermTargetTemplate = (rowData) => {
    return <InputNumber value={rowData.nearTermTarget} onValueChange={(e) => onInputChange(e, rowData, "nearTermTarget")} placeholder="Enter Value" />;
  };

  const targetStatementTemplate = (rowData) => {
    return <InputText value={rowData.targetStatement} onChange={(e) => onInputChange(e, rowData, "targetStatement")} placeholder="Enter statement" />;
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    setFilters((prevFilters) => ({
      ...prevFilters,
      global: { value: value, matchMode: FilterMatchMode.CONTAINS },
    }));
    setGlobalFilterValue(value);
  };

  //Fetch API for Graph Data
  const fetchGraphData = async () => {
    const requestBody = {
      companyNames: formData.companyName?.length > 0 ? [formData.companyName] : [],
      sectors: formData.sector?.length > 0 ? formData.sector : [],
      countries: formData.country?.length > 0 ? formData.country : [],
      competitors: formData.competitors?.length > 0 ? formData.competitors : [],
      years: formData.year ? formData.year : null,
    };
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API_URL}emission-benchmarking-graph`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestBody),
        }
      );

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const result = await response.json();
      setGraphData(result);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  const onTabChange = async (e) => {
    setActiveIndex(e.index);
    // Reset filters for the newly selected tab
    setFormData({
      companyName: [],
      sector: [],
      country: [],
      competitors: [],
      year: "",
    });
    setLoading(true);
    try {
      let url = "";
      let requestBody = {};
      // Determine API and request body based on the active tab
      if (e.index === 0) {
        url = `${process.env.REACT_APP_BASE_API_URL}emission-benchmarking-filter`;
        requestBody = formData;
      } else if (e.index === 1) {
        url = `${process.env.REACT_APP_BASE_API_URL}emission-targets-filter`;
        requestBody = {
          companyNames: [],
          sectors: [],
          countries: [],
          competitors: [],
          years: [],
        };
      } else if (e.index === 2) {
        url = `${process.env.REACT_APP_BASE_API_URL}esg-reporting-filter`;
        requestBody = {
          companyNames: [],
          sectors: [],
          countries: [],
          competitors: [],
        };
      }

      // Fetch data for the selected tab
      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          username,
        },
        body: JSON.stringify(requestBody),
      });

      if (res.status === 200) {
        const responseJson = await res.json();

        // Update the data state based on the active tab
        if (e.index === 0) {
          console.log("Emission");
          setCompanyOptions(responseJson.companyNames.map((name) => ({ label: name, value: name })));
          setSectorOptions(responseJson.sectors.map((name) => ({ label: name, value: name })));
          setCountryOptions(responseJson.countries.map((name) => ({ label: name, value: name })));
          const competitorsOptions = Object.entries(responseJson.competitors).map(([name, isSelected]) => ({
            label: name,
            value: name,
            selected: isSelected, // true if the value is true, false otherwise
          }));
          setCompetitorsOptions(competitorsOptions);
          setYearOptions(responseJson.years.map((name) => ({ label: name, value: name })));
        } else if (e.index === 1) {
          console.log("Targets");
          setCompanyOptions(responseJson.companyNames.map((name) => ({ label: name, value: name })));
          setSectorOptions(responseJson.sectors.map((name) => ({ label: name, value: name })));
          setCountryOptions(responseJson.countries.map((name) => ({ label: name, value: name })));
          const competitorsOptions = Object.entries(responseJson.competitors).map(([name, isSelected]) => ({
            label: name,
            value: name,
            selected: isSelected, // true if the value is true, false otherwise
          }));
          setCompetitorsOptions(competitorsOptions);
          setYearOptions(responseJson.years.map((name) => ({ label: name, value: name })));
        } else if (e.index === 2) {
          console.log("Reporting");
          setCompanyOptions(responseJson.companyNames.map((name) => ({ label: name, value: name })));
          setSectorOptions(responseJson.sectors.map((name) => ({ label: name, value: name })));
          setCountryOptions(responseJson.countries.map((name) => ({ label: name, value: name })));
          const competitorsOptions = Object.entries(responseJson.competitors).map(([name, isSelected]) => ({
            label: name,
            value: name,
            selected: isSelected, // true if the value is true, false otherwise
          }));
          setCompetitorsOptions(competitorsOptions);
          setYearFilter("");
        }
      } else {
        console.error(`Error fetching data for tab index ${e.index}`);
      }
    } catch (error) {
      console.error("Error", error);
    } finally {
      await new Promise((resolve) => setTimeout(resolve, 5000));
      setLoading(false);
    }
  };

  //Graph API


  const onPageLoadFilter = async () => {
    const e = activeIndex;
    // Reset filters for the newly selected tab
    const requestBody1 = {
      companyNames: formData.companyName?.length > 0 ? [formData.companyName] : [],
      sectors: formData.sector?.length > 0 ? formData.sector : [],
      countries: formData.country?.length > 0 ? formData.country : [],
      competitors: formData.competitors?.length > 0 ? formData.competitors : [],
      years: formData.year?.length > 0 ? [formData.year] : [],
    };
    console.log(formData);

    setLoading(true);
    try {
      let url = "";
      let requestBody = {};
      // Determine API and request body based on the active tab
      if (e === 0) {
        url = `${process.env.REACT_APP_BASE_API_URL}emission-benchmarking-filter`;
        requestBody = requestBody1;
      } else if (e === 1) {
        url = `${process.env.REACT_APP_BASE_API_URL}emission-targets-filter`;
        requestBody = requestBody1;
      } else if (e === 2) {
        url = `${process.env.REACT_APP_BASE_API_URL}esg-reporting-filter`;
        requestBody = {
          companyNames: [formData.companyName],
          sectors: [formData.sector],
          countries: [formData.country],
          competitors: [formData.competitors],
          years: [formData.year],
        };
      }

      // Fetch data for the selected tab
      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          username,
        },
        body: JSON.stringify(requestBody),
      });

      if (res.status === 200) {
        const responseJson = await res.json();

        // Update the data state based on the active tab
        if (e === 0) {
          console.log("Emission");
          setCompanyOptions(responseJson.companyNames.map((name) => ({ label: name, value: name })));
          setSectorOptions(responseJson.sectors.map((name) => ({ label: name, value: name })));
          setCountryOptions(responseJson.countries.map((name) => ({ label: name, value: name })));
          const competitorsOptions = Object.entries(responseJson.competitors).map(([name, isSelected]) => ({
            label: name,
            value: name,
            selected: isSelected, // true if the value is true, false otherwise
          }));
          setCompetitorsOptions(competitorsOptions);
          setYearOptions(responseJson.years.map((name) => ({ label: name, value: name })));
        } else if (e === 1) {
          console.log("Targets");
          setCompanyOptions(responseJson.companyNames.map((name) => ({ label: name, value: name })));
          setSectorOptions(responseJson.sectors.map((name) => ({ label: name, value: name })));
          setCountryOptions(responseJson.countries.map((name) => ({ label: name, value: name })));
          const competitorsOptions = Object.entries(responseJson.competitors).map(([name, isSelected]) => ({
            label: name,
            value: name,
            selected: isSelected, // true if the value is true, false otherwise
          }));
          setCompetitorsOptions(competitorsOptions);
          setYearOptions(responseJson.years.map((name) => ({ label: name, value: name })));
        } else if (e === 2) {
          console.log("Reporting");
          setCompanyOptions(responseJson.companyNames.map((name) => ({ label: name, value: name })));
          setSectorOptions(responseJson.sectors.map((name) => ({ label: name, value: name })));
          setCountryOptions(responseJson.countries.map((name) => ({ label: name, value: name })));
          const competitorsOptions = Object.entries(responseJson.competitors).map(([name, isSelected]) => ({
            label: name,
            value: name,
            selected: isSelected, // true if the value is true, false otherwise
          }));
          setCompetitorsOptions(competitorsOptions);
          setYearFilter("");
        }
      } else {
        console.error(`Error fetching data for tab index ${e.index}`);
      }
    } catch (error) {
      console.error("Error", error);
    } finally {
      await new Promise((resolve) => setTimeout(resolve, 5000));
      setLoading(false);
    }
  };

  const getTabTitle = () => {
    switch (activeIndex) {
      case 0:
        return "Emissions Benchmarking";
      case 1:
        return "Emissions Targets";
      case 2:
        return "ESG Reporting Standards/Frameworks​";
      default:
        return "Emissions Benchmarking";
    }
  };

  const renderHeader = () => {
    return (
      <div className="flex justify-content-end">
        <span className="p-input-icon-left">
          <img src="assets/img/search.png" className="search-i" alt="search" />
          <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search" />
        </span>
      </div>
    );
  };

  const header = renderHeader();

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: "#00366D26",
      background: "#F5F5F5",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#407775", // Change border color on hover
      },
      fontSize: fontSize, // Set font size for control (including selected option)
      color: "#707070!important", // Set default text color for the control
      paddingLeft:
        state.selectProps.name === "companyName" && (!formData.companyName || formData.companyName.length === 0)
          ? "30px"
          : state.selectProps.name === "sector" && (!formData.sector || formData.sector.length === 0)
          ? "30px"
          : state.selectProps.name === "region" && (!formData.region || formData.region.length === 0)
          ? "30px"
          : state.selectProps.name === "country" && (!formData.country || formData.country.length === 0)
          ? "30px"
          : state.selectProps.name === "competitors" && (!formData.competitors || formData.competitors.length === 0)
          ? "30px"
          : state.selectProps.name === "year" && (!formData.year || formData.year.length === 0)
          ? "30px"
          : "0px", // Default padding if the field is filled
      position: "relative",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#707070",
      width: "32px",
      height: "32px",
      display: "flex",
      alignItems: "center",
      "&:hover": {
        color: "#707070", // Change border color on hover
      },
    }),
    indicatorSeparator: () => ({
      display: "none", // Hide the separator
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999, // Ensure the menu is above other elements
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused || state.isSelected ? "#eef1f5" : "white", // Hover and selected background color
      color: state.isSelected ? "#407775" : "#707070", // Change text color for selected options
      fontSize: fontSize, // Use fontSize state variable for options
      "&:active": {
        backgroundColor: "#eef1f5", // Change color on active (click)
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: fontSize, // Set font size for the placeholder
      color: "#707070", // Set placeholder color
    }),
  };

   useEffect(() => {
      if (emissionsData.length > 0) {
        if(formData.competitors.length === 0){
          const filteredEmissions = emissionsData.filter((item) => {
            const matchesCompany = !formData.companyName || formData.companyName.length === 0 || formData.companyName.includes(item.companyName);
            const matchesSector = formData.sector.length === 0 || formData.sector.includes(item.sector);
            const matchesCountry = formData.country.length === 0 || formData.country.includes(item.country);
            const matchesYear = !formData.year || formData.year.length === 0 || (Array.isArray(formData.year) && formData.year.some(year => item.year === year)) || (typeof formData.year === 'string' && item.year === formData.year);
      
            return matchesCompany && matchesSector && matchesCountry && matchesYear;
          });
          console.log("If Condtition");
          setFilteredEmissionsData(filteredEmissions);
        }
        else{
          console.log("Else Condtition");
          
        }
      } else {
        // console.log("No emissions data found.");
        setFilteredEmissionsData([]); // Prevent errors
      }
    }, [emissionsData, formData]);
    
    useEffect(() => {
      if (!Array.isArray(targetsData) || targetsData.length === 0) {
        // console.error("targetsData is empty or not an array!", targetsData);
        setFilteredTargetsData([]); // Prevent errors
        return;
      }
    
      const filteredTargets = targetsData.filter((item) => {
        const matchesCompany = !formData.companyName || formData.companyName.length === 0 || formData.companyName.includes(item.companyName);
        const matchesSector = formData.sector.length === 0 || formData.sector.includes(item.sector);
        const matchesCountry = formData.country.length === 0 || formData.country.includes(item.country);
        const matchesYear = !formData.year || formData.year.length === 0 || (Array.isArray(formData.year) && formData.year.some(year => item.year === year)) || (typeof formData.year === 'string' && item.year === formData.year);
    
        return matchesCompany && matchesSector && matchesCountry && matchesYear;
      });
    
      // console.log("Filtered Targets Data:", filteredTargets);
      setFilteredTargetsData(filteredTargets);
    }, [targetsData, formData]);    
  
    useEffect(() => {
      if (!Array.isArray(reportingData) || reportingData.length === 0) {
        // console.error("reportingData is empty or not an array!", reportingData);
        setFilteredReportingData([]);
        return;
      }
    
      const filteredReporting = reportingData.filter((item) => {
        const matchesCompany = !formData.companyName || formData.companyName.length === 0 || formData.companyName.includes(item.companyName);
        const matchesSector = formData.sector.length === 0 || formData.sector.includes(item.sector);
        const matchesCountry = formData.country.length === 0 || formData.country.includes(item.country);
    
        return matchesCompany && matchesSector && matchesCountry;
      });
    
      // console.log("Filtered Reporting Data:", filteredReporting);
      setFilteredReportingData(filteredReporting);
    }, [reportingData, formData]);
// Sample data for charts
// Sample data for tables
const emissionsTableData = [
  { company: "ANDRITZ AG", scope1: 190000, scope2: 150000, scope3: 1800000, total: 2140000 },
  { company: "CARGO PARTNER GMBH", scope1: 15000, scope2: 20000, scope3: 350000, total: 385000 },
  { company: "Donau Chemie AG", scope1: 50000, scope2: 30000, scope3: 20000, total: 100000 },
  { company: "ERSTE GROUP BANK AG", scope1: 15000, scope2: 70000, scope3: 1500000, total: 1585000 },
  { company: "EV Group GmbH", scope1: 1500, scope2: 2000, scope3: 5000, total: 8500 },
]

 // Simple component for displaying charts
 const EmissionsCharts = ({ companyName = "Gartner" }) => {
  // Donut chart for emissions by scope
  const donutChartOptions = {
    chart: {
      type: "pie",
      height: 300,
      backgroundColor: "transparent",
    },
    title: {
      text: `GHG emissions (tCO2e) ${companyName}`,
      style: {
        fontSize: "14px",
        fontWeight: "500",
      },
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.y:,.0f} tCO2e</b>",
    },
    plotOptions: {
      pie: {
        innerSize: "60%",
        dataLabels: {
          enabled: true,
          distance: 30,
          connectorWidth: 1,
          connectorColor: "#666",
          format: "{point.name}: {point.y:,.0f} tCO2e",
          style: {
            fontWeight: "normal",
            fontSize: "11px",
          },
          connectorPadding: 5,
        },
        borderWidth: 0,
      },
    },
    series: [
      {
        name: "Emissions",
        data: [
          { name: "Scope 1", y: 5000, color: "#6F9896" },
          { name: "Scope 2", y: 25000, color: "#FAB430" },
          { name: "Scope 3", y: 100000, color: "#B4A34A" },
        ],
      },
    ],
    credits: { enabled: false },
  }

  // Bar chart for sector comparison
  const sectorComparisonOptions = {
    chart: {
      type: "column",
      height: 300,
      backgroundColor: "transparent",
    },
    title: {
      text: `GHG emissions comparison with sector average for ${companyName}`,
      style: {
        fontSize: "14px",
        fontWeight: "500",
      },
    },
    xAxis: {
      categories: ["Scope 1", "Scope 2", "Scope 3"],
      crosshair: true,
    },
    yAxis: {
      min: 0,
      title: {
        text: "Emissions (tCO2e)",
      },
      labels: {
        formatter: function () {
          return this.value.toLocaleString()
        },
      },
    },
    tooltip: {
      shared: true,
      useHTML: true,
      headerFormat: "<table>",
      pointFormat:
        '<tr><td style="color: {series.color};">{series.name}: </td>' +
        '<td style="text-align: right"><b>{point.y:,.0f} tCO2e</b></td></tr>',
      footerFormat: "</table>",
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
        pointWidth: 25, // Reduced bar width
      },
    },
    series: [
      {
        name: "Company specific GHG emissions (tCO2e)",
        color: "#B4C9C8", // Updated to the requested color
        data: [5000, 8750, 50000],
      },
      {
        name: "Sector average (tCO2e)",
        color: "#FAB430", // Updated to the requested color
        data: [6750, 23500, 247500],
      },
    ],
    credits: { enabled: false },
  }

  // Bar chart for peer comparison
  const peerComparisonOptions = {
    chart: {
      type: "column",
      height: 300,
      backgroundColor: "transparent",
    },
    title: {
      text: `GHG emissions comparison with industry peers of ${companyName}`,
      style: {
        fontSize: "14px",
        fontWeight: "500",
      },
    },
    xAxis: {
      categories: ["Scope 1", "Scope 2", "Scope 3"],
      crosshair: true,
    },
    yAxis: {
      min: 0,
      title: {
        text: "Emissions (tCO2e)",
      },
      labels: {
        formatter: function () {
          return this.value.toLocaleString()
        },
      },
    },
    tooltip: {
      shared: true,
      useHTML: true,
      headerFormat: "<table>",
      pointFormat:
        '<tr><td style="color: {series.color};">{series.name}: </td>' +
        '<td style="text-align: right"><b>{point.y:,.0f} tCO2e</b></td></tr>',
      footerFormat: "</table>",
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
        pointWidth: 15, // Reduced bar width
      },
    },
    series: [
      {
        name: "Gartner",
        color: "#6F9896", // Updated to the requested color
        data: [5000, 8750, 50000],
      },
      ...Object.keys(graphData.scope1GHGEmissionWithIndustryPeers).map(peer => ({
        name: peer,
        color: "#FAB430",
        data: [
          graphData.scope1GHGEmissionWithIndustryPeers[peer],
          graphData.scope2GHGEmissionWithIndustryPeers[peer],
          graphData.scope3GHGEmissionWithIndustryPeers[peer]
        ],
      })),
    ],
    credits: { enabled: false },
  }

  // Bar chart for intensity comparison
  const intensityOptions = {
    chart: {
      type: "bar",
      height: 300,
      backgroundColor: "transparent",
    },
    title: {
      text: `Emission intensity comparison with industry peers of ${companyName}`,
      style: {
        fontSize: "14px",
        fontWeight: "500",
      },
    },
    xAxis: {
      categories: [companyName, ...Object.keys(graphData.emissionIntensityPerEmployee)],
      title: { text: null },
    },
    yAxis: [
      {
        min: 0,
        title: {
          text: "",
          align: "high",
        },
        labels: {
          overflow: "justify",
        },
      },
    ],
    tooltip: {
      shared: true,
      useHTML: true,
      headerFormat: "<table>",
      pointFormat:
        '<tr><td style="color: {series.color};">{series.name}: </td>' +
        '<td style="text-align: right"><b>{point.y:.2f}</b></td></tr>',
      footerFormat: "</table>",
    },
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: true,
          format: "{y:.2f}",
        },
      },
    },
    series: [
      {
        name: "Economic emission intensity (tCO2e/currency)",
        color: "#B4A34A",
        data: [
          graphData.economicEmissionIntensity[companyName],
          ...Object.values(graphData.economicEmissionIntensity)
        ],
      },
      {
        name: "Emission intensity per employee (tCO2e/employee)",
        color: "#6F9896",
        data: [
          graphData.emissionIntensityPerEmployee[companyName],
          ...Object.values(graphData.emissionIntensityPerEmployee)
        ],
      },
    ],
    credits: { enabled: false },
  }

  return (
    <div className="row">
      <div className="col-md-6 mb-4">
        <div className="card">
          <div className="card-body">
            <HighchartsReact highcharts={Highcharts} options={donutChartOptions} />
            <div className="d-flex justify-content-center mt-3">
              <div className="d-flex align-items-center me-3">
                <div
                  style={{
                    width: "12px",
                    height: "12px",
                    backgroundColor: "#6F9896",
                    borderRadius: "50%",
                    marginRight: "8px",
                  }}
                ></div>
                <span className="small">Scope 1</span>
              </div>
              <div className="d-flex align-items-center me-3">
                <div
                  style={{
                    width: "12px",
                    height: "12px",
                    backgroundColor: "#FAB430",
                    borderRadius: "50%",
                    marginRight: "8px",
                  }}
                ></div>
                <span className="small">Scope 2</span>
              </div>
              <div className="d-flex align-items-center me-3">
                <div
                  style={{
                    width: "12px",
                    height: "12px",
                    backgroundColor: "#B4A34A",
                    borderRadius: "50%",
                    marginRight: "8px",
                  }}
                ></div>
                <span className="small">Scope 3</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-6 mb-4">
        <div className="card">
          <div className="card-body">
            <HighchartsReact highcharts={Highcharts} options={sectorComparisonOptions} />
          </div>
        </div>
      </div>

      <div className="col-md-6 mb-4">
        <div className="card">
          <div className="card-body">
            <HighchartsReact highcharts={Highcharts} options={peerComparisonOptions} />
          </div>
        </div>
      </div>

      <div className="col-md-6 mb-4">
        <div className="card">
          <div className="card-body">
            <HighchartsReact highcharts={Highcharts} options={intensityOptions} />
          </div>
        </div>
      </div>
    </div>
  )
}

  return (
    <div id="wrapper">
      {loading && (
        <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <div id="">
        <header>
          <nav className="navbar navbar-expand-lg navbar-light" style={{ background: "#407775" }}>
            <div className="container-fluid  mx-4 my-2">
              <div className="d-flex align-items-center">
                <a className="navbar-brand d-flex align-items-center p-0" href="#home">
                  <img src="assets/img/logo.png" alt="Company Logo" height="30" />
                </a>
                <div
                  className="mx-2"
                  style={{
                    borderLeft: "1px solid #fff",
                    height: "30px",
                    paddingLeft: "20px",
                    opacity: "0.5",
                  }}
                ></div>
                <span className="text-white" style={{ opacity: "0.7", fontSize: "14px" }}>
                  Organization Name
                </span>
              </div>
              <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
                <ul className="navbar-nav mb-2 mb-lg-0 d-flex align-items-center">
                  <li className="nav-item">
                    <a className="nav-link  text-white" href="#notifications">
                      <MdNotificationsActive className="icon" style={{ width: "1.5rem", height: "1.5rem" }} />
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link text-white" href="#profile">
                      <img className="icon mr-2" src="assets/img/User.png" alt="User" />
                    </a>
                  </li>
                  <li className="nav-item">
                    <span className="text-white" style={{ opacity: "0.7", fontSize: "14px" }}>
                      XYZ ltd
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </header>

        <div className="container survey-form scf p-4 p-lg-5">
          <div className="row">
            <div className="col">
              <Link to="/esg-benchmarking" style={{ color: "#407775", fontSize: "14px", textDecoration: "none" }}>
                  Home
              </Link>
            </div>
          </div>
          <div className="row my-4">
            <div className="col">
              <div className="form-header d-flex justify-content-between">
                <h1 className="title" style={{ color: "#494949" }}>
                  {getTabTitle()}
                </h1>
                <Button className="refresh-cta" onClick={resetSelections} variant="text" startIcon={<MdRefresh />}>
                  Reset Filters
                </Button>
              </div>
            </div>
          </div>
          <div className="form-part">
            <form>
              <div className="row gx-2 gy-3">
                <div className="col-xl-2 col-lg-4 col-md-6">
                  <label className="formlable">Company Name</label>
                  <div className="input-group position-relative">
                    {(!formData.companyName || formData.companyName.length === 0) && (
                      <span className="search-icon">
                        <img src="assets/img/search.png" alt="Search Icon" className="search-i" />
                      </span>
                    )}
                    <Select
                      name="companyName"
                      value={companyOptions.find((option) => option.value === formData.companyName) || null} // ✅ Ensure null resets it
                      options={companyOptions}
                      onChange={(e) => setFormData({ ...formData, companyName: e ? e.value : null })} // ✅ Ensure null if cleared
                      placeholder="Search"
                      isSearchable
                      styles={customStyles}
                      className="custom-select-with-icon wd-100"
                    />

                  </div>
                </div>

                <div className="col-xl-2 col-lg-4 col-md-6">
                  <label className="formlable">Sector</label>
                  <div className="input-group position-relative">
                    {(!formData.sector || formData.sector.length === 0) && ( // Conditionally render the search icon
                      <span className="search-icon">
                        <img src="assets/img/search.png" alt="Search Icon" className="search-i" />
                      </span>
                    )}
                    <Select
                      name="sector"
                      value={sectorOptions.filter((option) => formData.sector?.includes(option.value))}
                      options={sectorOptions}
                      onChange={(selectedOptions) => {
                        if (selectedOptions.length <= 5) {
                          setFormData({
                            ...formData,
                            sector: selectedOptions.map((opt) => opt.value),
                          });
                        }
                      }}
                      placeholder="Search"
                      isMulti
                      isSearchable
                      styles={customStyles}
                      className="custom-select-with-icon wd-100"
                      maxMenuHeight={200} // Limit dropdown height if needed
                    />
                  </div>
                </div>
                <div className="col-xl-2 col-lg-4 col-md-6">
                  <label className="formlable">Country</label>
                  <div className="input-group position-relative">
                    {(!formData.country || formData.country.length === 0) && ( // Conditionally render the search icon
                      <span className="search-icon">
                        <img src="assets/img/search.png" alt="Search Icon" className="search-i" />
                      </span>
                    )}
                    <Select
                      name="country"
                      value={countryOptions.filter((option) => formData.country?.includes(option.value))}
                      options={countryOptions}
                      onChange={(selectedOptions) => {
                        if (selectedOptions.length <= 5) {
                          setFormData({
                            ...formData,
                            country: selectedOptions.map((opt) => opt.value),
                          });
                        }
                      }}
                      placeholder="Search"
                      isMulti
                      isSearchable
                      styles={customStyles}
                      className="custom-select-with-icon wd-100"
                      maxMenuHeight={200} // Limit dropdown height if needed
                    />
                  </div>
                </div>

                <div className="col-xl-2 col-lg-4 col-md-6">
                  <label className="formlable">
                    Select Competitors <span style={{ fontSize: "10px" }}>(Upto 5)</span>
                  </label>
                  <div className="input-group position-relative">
                    {(!formData.competitors || formData.competitors.length === 0) && (
                      <span className="search-icon">
                        <img src="assets/img/search.png" alt="Search Icon" className="search-i" />
                      </span>
                    )}
                    <Select
                      name="competitors"
                      value={competitorsOptions.filter((option) => formData.competitors?.includes(option.value))}
                      options={competitorsOptions}
                      onChange={(selectedOptions) => {
                        console.log("Selected Competitors:", selectedOptions);
                        console.log("Form Data:", formData);
                        if (selectedOptions.length <= 5) {
                          setFormData({
                            ...formData,
                            competitors: selectedOptions.map((opt) => opt.value),
                          });
                        }
                      }}
                      placeholder="Search"
                      isMulti
                      isSearchable
                      styles={customStyles}
                      className="custom-select-with-icon wd-100"
                      maxMenuHeight={200} // Limit dropdown height if needed
                    />
                  </div>
                </div>
                {activeIndex !== 2 && (
                  <div className="col-xl-2 col-lg-4 col-md-6">
                    <label className="formlable">Year</label>
                    <div className="input-group position-relative">
                      {(!formData.year || formData.year.length === 0) && (
                        <span className="search-icon">
                          <img src="assets/img/search.png" alt="Search Icon" className="search-i" />
                        </span>
                      )}
                      <Select
                        name="year"
                        value={formData.year ? yearOptions.find((option) => option.value === formData.year) : null}
                        options={yearOptions}
                        onChange={(e) => setFormData({ ...formData, year: e.value })}
                        placeholder="Search"
                        isSearchable
                        styles={customStyles}
                        className="custom-select-with-icon wd-100"
                      />
                    </div>
                  </div>
                )}
              </div>
           {/* View Toggle */}
        <div className="d-flex mt-4 mb-4">
          <div className="btn-group">
            <button
              type="button"
              className={`btn ${viewMode === "table" ? "btn-toggle" : "btn-outline-toggle"}`}
              onClick={() => setViewMode("table")}
            >
              <Table className="me-1" /> Table
            </button>
            <button
              type="button"
              className={`btn ${viewMode === "graph" ? "btn-toggle" : "btn-outline-toggle"}`}
              onClick={() => setViewMode("graph")}
            >
              <BarChart className="me-1" /> Graph
            </button>
          </div>
        </div>

        {/* Content based on view mode */}
        {viewMode === "table" ? (
          <>

              <div className="row tabs mt-5">
                <TabView activeIndex={activeIndex} onTabChange={onTabChange}>
                  <TabPanel header="Emissions Benchmarking​">
                    <div className="data-responsive">
                      <DataTable
                        value={emissionsData}
                        paginator
                        rows={10}
                        rowsPerPageOptions={[10, 20, 25, 50]}
                        scrollable
                        scrollDirection="horizontal"
                        tableStyle={{ minWidth: "120rem" }}
                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        currentPageReportTemplate="{first} to {last} of {totalRecords}"
                        filters={filters}
                        filterDisplay="row"
                        globalFilterFields={["companyName", "sector", "country", "year", "revenue", "employees", "scope1Emissions", "scope2Emissions", "scope3Emissions", "totalEmissions", "economicEmissionIntensity", "emissionIntensityPerEmployees"]}
                        header={header}
                        emptyMessage="No data found."
                      >
                        <Column field="companyName" header="Company" sortable filter filterPlaceholder="Filter" style={{ width: "10%" }} />
                        <Column field="sector" header="Sector" sortable filter filterPlaceholder="Filter" style={{ width: "10%" }} />
                        <Column field="country" header="Country" sortable filter filterPlaceholder="Filter" style={{ width: "10%" }} />
                        <Column field="year" header="Year" sortable filter filterPlaceholder="Filter" style={{ width: "8%" }} />
                        <Column
                          field="revenue"
                          header="Revenue (in million USD)"
                          sortable
                          filter
                          filterPlaceholder="Filter"
                          style={{ width: "10%" }}
                          body={(rowData) => {
                            const roundedRevenue = Math.round(rowData.revenue);
                            return roundedRevenue.toLocaleString();
                          }}
                        />
                        <Column field="employees" header="Employees" sortable filter filterPlaceholder="Filter" style={{ width: "10%" }} />
                        <Column field="scope1Emissions" header="Scope 1 (tCO2e)" sortable filter filterPlaceholder="Filter" style={{ width: "8%" }} />
                        <Column field="scope2Emissions" header="Scope 2 (tCO2e)" sortable filter filterPlaceholder="Filter" style={{ width: "8%" }} />
                        <Column field="scope3Emissions" header="Scope 3 (tCO2e)" sortable filter filterPlaceholder="Filter" style={{ width: "8%" }} />
                        <Column field="totalEmissions" header="Total emissions (tCO2e)" sortable filter filterPlaceholder="Filter" style={{ width: "10%" }} />
                        <Column field="economicEmissionIntensity" header="Economic emission intensity (tCO2e/mn USD)" sortable filter filterPlaceholder="Filter" style={{ width: "20%" }} />
                        <Column field="emissionIntensityPerEmployees" header="Emission  intensity per  employee  (tCO2e/ pax)" sortable filter filterPlaceholder="Filter" style={{ width: "20%" }} />

                        
                      </DataTable>
                    </div>
                  </TabPanel>
                  <TabPanel header="Emissions Targets">
                    <div className="data-responsive">
                      <DataTable
                        value={targetsData}
                        paginator
                        rows={10}
                        rowsPerPageOptions={[10, 20, 25, 50]}
                        scrollable
                        scrollDirection="horizontal"
                        tableStyle={{ minWidth: "50rem" }}
                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        currentPageReportTemplate="{first} to {last} of {totalRecords}"
                        emptyMessage="No data found."
                      >
                        <Column field="companyName" header="Company" sortable style={{ width: "10%" }} />
                        <Column field="sector" header="Sector" sortable style={{ width: "10%" }} />
                        <Column field="country" header="Country" sortable style={{ width: "10%" }} />
                        <Column field="netZeroCommitted" header="Net Zero target" style={{ width: "10%" }} />
                        <Column field="netZeroYear" header="Net Zero year" sortable style={{ width: "10%" }} />
                        <Column field="nearTermTargetStatus" header="Near-term target" style={{ width: "10%" }} />
                        <Column field="nearTermTargetYear" header="Near-term target year" sortable style={{ width: "10%" }} />
                        <Column field="target" header="Target statement" style={{ width: "20%" }} />
                        <Column field="date" header="Update date" sortable style={{ width: "10%" }} />
                      </DataTable>
                    </div>
                  </TabPanel>
                  <TabPanel header="ESG Reporting Standards/Frameworks​​">
                    <div className="data-responsive">
                      <DataTable
                        value={reportingData}
                        paginator
                        rows={10}
                        rowsPerPageOptions={[10, 20, 25, 50]}
                        scrollable
                        scrollDirection="horizontal"
                        tableStyle={{ minWidth: "50rem" }}
                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        currentPageReportTemplate="{first} to {last} of {totalRecords}"
                        emptyMessage="No data found."
                      >
                        <Column field="companyName" header="Company" sortable style={{ width: "10%" }} />
                        <Column field="sector" header="Sector" sortable style={{ width: "10%" }} />
                        <Column field="country" header="Country" body={(rowData) => rowData.country.replace(/["\[\]\s]/g, "")} sortable style={{ width: "10%" }} />
                        <Column field="reportingStandards" header="Reporting Standards/Regulations Followed" sortable style={{ width: "35%" }} />
                        <Column field="sustainabilityFocusAreas" header="Key Sustainability Focus Areas" sortable style={{ width: "35%" }} />
                      </DataTable>
                    </div>
                  </TabPanel>
                </TabView>
              </div>
              </>
            ) : (
         
          <EmissionsCharts companyName="Gartner" />
        )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ESGBenchmarking;
